import { observer } from "mobx-react";
import { APIClient } from "network-stapler";
import React from "react";
import Formular from "../Components/Formular";
import LoadingIndicatorWrapper from "../Components/LoadingIndicatorWrapper";
import StepsNavigation from "../Components/StepsNavigation";
import { generalConfigurationStore as store } from "../Stores/GeneralConfigurationStore";
import "./OrderSubmitPage.css";
import productPlaceholder from "../Images/placeholder_config_image.png";

type Props = {
	apiClientDynamicBaseUrl: APIClient;
};

type State = {
	title: string;
	pageIsActive: number;
};

@observer
class OrderSubmitPage extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		// set initial state
		this.state = {
			title: "OrderSubmitPage",
			pageIsActive: 4,
		};
	}

	componentDidMount() {
		this.setState({
			title: "OrderSubmitPage Loaded",
		});
	}

	render() {
		const selectedModulesCounter = store.productConfigurationStore?.formattedNumberOfSelectedModules;
		const imageUrl = store.productConfigurationStore?.product?.productBase?.image?.url ? store.productConfigurationStore?.product?.productBase?.image?.url : productPlaceholder;

		return (
			<div className="order-submit-page">
				{store.productConfigurationStore?.isLoading ? (
					<LoadingIndicatorWrapper />
				) : (
					<>
						<StepsNavigation
							pageIsActive={this.state.pageIsActive}
							sublineStep1={selectedModulesCounter}
							sublineStep2={store.configs?.sublineSummary}
							sublineStep3={store.configs?.sublineSalesPartner}
						/>
						<div className="container text-left">
							<div className="row">
								<div className="col-12">
									<h1>{store.configs?.submitSubmitMainHeadline}</h1>
								</div>
								<div className="col-lg-4">
									<h2 className="headline-spacing">{store.configs?.submitConfigHeadline}</h2>
									<div className="product-config-tile">
										<div className="product-config-tile-image">
											<img
												className="product-image"
												src={imageUrl}
												alt={store.productConfigurationStore?.product?.title?.rendered}
											/>
											{store.productConfigurationStore?.getRenderImages.map((imageUrl: string, i) => {
												return <img src={imageUrl} alt="" className="config-image" key={`${i}-renderImage`} />;
											})}
										</div>
										<div className="text-wrapper">
											<h3>{store.configs?.submitProductHeadline}</h3>
											<p>{store.productConfigurationStore?.product?.title?.rendered}</p>
										</div>
										<div className="text-wrapper">
											<h3>{store.configs?.submitModuleSelectionHeadline}</h3>
											<p>{selectedModulesCounter}</p>
										</div>
									</div>
								</div>
								<div className="col-lg-4 offset-lg-1 contact-section">
									<h2>{store.configs?.submitContactInformationHeadline}</h2>
									<Formular apiClientDynamicBaseUrl={this.props.apiClientDynamicBaseUrl} />
								</div>
							</div>
						</div>
					</>
				)}
			</div>
		);
	}
}

export default OrderSubmitPage;
